import api from '../../api/api';
import {GET_GEO_DATA} from '../actionTypes';
import {UPDATE_GEO_DATA} from '../mutationTypes';

export default {
  [GET_GEO_DATA]: async ({commit}) => {
    const geoData = await api.geo.get_geo_data();
    commit(UPDATE_GEO_DATA, geoData);
  },
};
